import HistoryGrid from './HistoryGrid';

export default HistoryGrid;
